import { FC } from 'react';

import { twMerge } from 'tailwind-merge';

import { CurrencyIcon as DefaultCurrencyIcon } from '@/shared/assets';
import { Flag } from '@/shared/ui';

import { CURRENCY_TO_COUNTRY_MAPPING } from '../../config';
import { ICurrencyIcon } from './types';

export const CurrencyIcon: FC<ICurrencyIcon> = ({
  ticker,
  size = 'sm',
  className,
  isLoading,
}) => {
  const alpha2 = ticker && CURRENCY_TO_COUNTRY_MAPPING[ticker];

  return (
    <Flag
      FallbackIcon={<DefaultCurrencyIcon className="h-full w-full" />}
      alpha2={alpha2 || undefined}
      isLoading={isLoading}
      className={twMerge(
        size === 'sm' && 'h-6 w-6',
        size === 'md' && 'h-[34px] w-[34px]',
        size === 'lg' && 'h-10 w-10',
        size === 'xl' && 'h-[56px] w-[56px]',
        className,
      )}
    />
  );
};
